module.exports = __webpack_public_path__ + "img/Weapon_160.053fa1f3.png";